var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"10px"}}),_c('el-pagination',{attrs:{"current-page":_vm.pageinfo.currentpage,"page-size":_vm.pageinfo.pageSize||10,"layout":"total, prev, pager, next, jumper","total":_vm.pageinfo.total},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }